import { Base } from './base.model';

export interface Event extends Base {
  type: number;
  user_agent: any;
  context: any;
  user_id?: string;
}

export enum EventTypes {
  LOGIN_FAILED = 1,
  LOGIN_SUCCESSFUL = 2,
  DOCUMENT_DOWNLOAD = 3,
  DOCUMENT_SIGN_TRY = 4,
  DOCUMENT_SIGN_SUCCESS = 5,
  DOCUMENT_SIGN_FAIL = 6,
  QUESTIONNAIRE_NEXT_PAGE = 7,
  QUESTIONNAIRE_COMPLETED = 8,
  FAQ_READ = 9,
  ELIGIBILITY_CRITERIA_FAIL = 10,
  ELIGIBILITY_CRITERIA_SUCCESS = 11,
  KYC_FAIL = 12,
  KYC_SUCCESS = 13,
  CLIENT_ONBOARDED = 14,
  CPF_CHECK = 15,
  ELEGIBILITY_QUEST_LOAD_PAGE = 16,
  IDENTIFICATION_QUEST_LOAD_PAGE = 17,
  KYC_DOC_SELECTION_LOAD_PAGE = 18,
  SHARE_INVITE_CLICK = 19,
  SIGNATURE_DOC_LIST_LOAD_PAGE = 22,
  SIGNATURE_CANVA_LOAD_PAGE = 23,
  SIGN_IN_CONFIRMATION_LOAD_PAGE = 24,
  KYC_DOC_SENDING_LOAD_PAGE = 20,
  KYC_PROCESS_LOAD_PAGE = 21,
  KYC_DOC_SOURCE_PHOTO = 25,
  KYC_DOC_SOURCE_LOAD = 26,
  BRB_LOAD_PAGE = 27,
  KYC_TRY_AGAIN = 28,
  PHYSICAL_CNH_SELECTED = 29,
  DIGITAL_CNH_SELECTED = 30,
  CLAIM_STATUS_UPDATED = 31,
  VIDEO_START = 32,
  VIDEO_PAUSE = 33,
  VIDEO_RESUME = 34,
  VIDEO_PROGRESS_HEARTBEAT = 35,
  VIDEO_CLOSE = 36,
  VIDEO_COMPLETED = 37,
  VIDEO_CONTINUE_CLICK = 38,
  VIDEO_ACCEPT_CLICK = 39,
  // SomosKycV1 frontend pre-check: user did not confirm the document's data is
  // theirs (proceeded with an explanation, restarted, or amended their saved details).
  KYC_PRECHECK_NOT_CONFIRMED = 40,
  // SomosKycV1 frontend pre-check: the weighted confidence score was high enough to
  // skip the pre-review modal and submit automatically (document clearly the user's).
  KYC_PRECHECK_AUTO_PROCEED = 61,
  // Full client-side trace of a KYC attempt (capture method, model classification, OCR, QR,
  // pre-review proposals + user edits/rejections/notes, submit, result) — the timeline payload.
  KYC_ATTEMPT_TRACE = 62,
  // SomosKycV1: the heavy on-device stack (ONNX classify/segment, Tesseract OCR, brdocs
  // preprocess) was skipped because the device is too weak or a step overran its budget.
  // `context.reason` is static_pregate | load_timeout | load_error | capture_budget.
  KYC_ONDEVICE_PROCESSING_SKIPPED = 66,
  // SomosKycV1 (backend-emitted): a Veriff watchlist `possible_match` (PEP/sanction) was
  // released — CPF corroboration against our own base refuted the namesake, so the hit did NOT
  // fail the KYC. Emitted for audit whenever a possible_match is downgraded to no_match.
  KYC_WATCHLIST_CORROBORATION_RELEASED = 67,
  // SomosKycV1 (frontend-emitted): the live-capture camera stream was acquired for a capture
  // flow. Fires once per flow with the device's camera settings + focus/torch/zoom capabilities.
  KYC_CAMERA_STREAM_STARTED = 68
}
